import { action, observable } from 'mobx';

class BasicQueryCheckboxStore{
    @observable accessor value = null;

    @action.bound
    setValue(v) {
        this.value = v;
    }

    @action.bound
    reset() {
        this.value = null;
    }

    constructor() {
    }
}

export default BasicQueryCheckboxStore;